import React from 'react'
import Iframe from 'react-iframe'

const Contact = (props) => (
    <section id="contact">
        <div className="inner">
            <section>

                <h4>Things to do in Portsmouth, UK</h4>
                <Iframe url=" https://www.tripadvisor.com/Attractions-g186298-Activities-Portsmouth_Hampshire_England.html"
                        width="100%"
                        height="400px"
                        id="trip-advisor-iframe"
                        className="tripadvisor-wrapper"
                        position="relative"
                />
                <br/>
                <hr/>
                <h4 className="contact-heading">Get in touch</h4>
                <form method="POST" name="contact" data-netlify="true">
                    <div className="field half first">
                        <label htmlFor="name">Name</label>
                        <input type="text" name="name" id="name" />
                    </div>
                    <div className="field half">
                        <label htmlFor="email">Email</label>
                        <input type="text" name="email" id="email" />
                    </div>
                    <div className="field">
                        <label htmlFor="message">Message</label>
                        <textarea name="message" id="message" rows="6"></textarea>
                    </div>
                    <div data-netlify-recaptcha></div>
                    <ul className="actions">
                        <li><input type="submit" value="Send Message" className="special" /></li>
                        <li><input type="reset" value="Clear" /></li>
                    </ul>
                </form>


            </section>

            <section className="split" id="news">

                <section>
                    <h4>The news</h4>
                    <Iframe url="https://www.portsmouth.co.uk/news/"
                            width="100%"
                            height="400px"
                            id="portsmouth-news-iframe"
                            className="portsmouth-wrapper"
                            position="relative"
                    />
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-arrow-right"></span>
                        <a href="/news/gay-asylum-seeker-deportation">Concern over gay asylum seeker deportation</a>
                    </div>
                    <div className="contact-method">
                        <span className="icon alt fa-arrow-right"></span>
                        <a href="/portsmouth">Portsmouth, UK</a>
                    </div>
                    <div className="contact-method">
                        <span className="icon alt fa-arrow-right"></span>
                        <a href="/news/hms-queen-elizabeth">HMS Queen Elizabeth: Was It Necessary?</a>
                    </div>
                    <div className="contact-method">
                        <span className="icon alt fa-arrow-right"></span>
                        <a href="/mps-for-portsmouth">MPs For Portsmouth</a>
                    </div>
                    <div className="contact-method">
                        <span className="icon alt fa-arrow-right"></span>
                        <a href="/news/homeowners-forced-to-accept-lower-prices-portsmouth">Homeowners Forced To Accept Lower Sale Prices in Portsmouth</a>
                    </div>
                    <div className="contact-method">
                        <span className="icon alt fa-arrow-right"></span>
                        <a href="/news/shelter-for-the-homeless">Shelter For The Homeless</a>
                    </div>

                </section>
            </section>

        </div>
    </section>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js